<template>
  <div>
    <el-table
      v-if="showTable"
      :data="feedbackScoreList"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      empty-text="ไม่พบข้อมูล"
    >
      <el-table-column
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        sortable
        :index="(index) => indexMethod(index, page, pageSize)"
        :width="widthMax < 767.98 ? '78' : widthMax < 991 ? '60' : '78'"
      ></el-table-column>
      <el-table-column
        prop="nameTH"
        label="ชื่อ"
        header-align="center"
        align="center"
        sortable
        :width="
          widthMax < 767.98
            ? '150'
            : widthMax < 1150
            ? ''
            : widthMax < 1920
            ? ''
            : '300'
        "
      ></el-table-column>
      <el-table-column
        prop="surnameTH"
        label="นามสกุล"
        header-align="center"
        align="center"
        sortable
        :width="
          widthMax < 767.98
            ? '150'
            : widthMax < 1150
            ? ''
            : widthMax < 1920
            ? ''
            : '300'
        "
      ></el-table-column>
      <el-table-column
        prop="companyName"
        label="ชื่อบริษัท"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '150'
            : widthMax < 991
            ? '100'
            : widthMax < 1920
            ? '120'
            : ''
        "
        sortable
      ></el-table-column>
      <el-table-column
        prop="mobilephone"
        label="เบอร์โทรศัพท์"
        header-align="center"
        align="center"
        :width="
          widthMax < 1920
          ? '115'
          : '200'
        "
      ></el-table-column>
      <el-table-column
        prop="score"
        label="คะแนนประเมินเฉลี่ย"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '120'
            : widthMax < 1150
            ? '120'
            : widthMax < 1920
            ? ''
            : '300'
        "
        sortable
      >
        <template slot-scope="scope"
          >{{ scope.row.avg ? scope.row.avg.toFixed(1) : 0 }} คะแนน</template
        >
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="วันที่และเวลาที่สมัคร"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '120'
            : widthMax < 991
            ? '130'
            : widthMax < 1150
            ? '200'
            : widthMax > 1199.98
            ? '250'
            : ''
        "
      >
        <template slot-scope="scope">{{
          scope.row.updatedAt | dateTimeTh
        }}</template>
      </el-table-column>
      <el-table-column label width="50" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="box-action">
            <div
              @click="
                $router.push(
                  `/feedback/view?courseId=${courseId}&userId=${scope.row._id}`
                )
              "
              class="circle-action color-bg-secondary"
            >
              <i class="fas fa-eye"></i>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="feedbackScoreListConst.length > pageSize" class="pd-y-3">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next"
        :total="feedbackScoreListConst.length"
        :page-size="pageSize"
        :current-page="page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";

export default {
  props: {
    feedbackScoreListConst: {
      type: Array,
      default() {
        return [];
      },
    },
    courseId: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    feedbackScoreList() {
      return this.feedbackScoreListConst.slice(
        (this.page - 1) * this.pageSize,
        this.page * this.pageSize
      );
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      page: 1,
      pageSize:10
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    changePage(page) {
      this.page = page;
    },
  },
};
</script>